// LessonView.tsx — the Hub/public-page lesson renderer. Resolves related lessons
// from the bundled catalog and delegates rendering to LessonViewBase, which the
// partner embed uses directly with its own (fetched) catalog.
import React from 'react';
import { LessonMeta } from './types';
import { listLessons } from './lessonContent';
import LessonViewBase, { LessonViewBaseProps } from './LessonViewBase';

export type LessonViewProps = Omit<LessonViewBaseProps, 'relatedLessons'>;

export default function LessonView(props: LessonViewProps) {
  const { lesson } = props;
  const related = lesson.related
    .map((slug) => listLessons().find((l) => l.slug === slug))
    .filter((l): l is LessonMeta => !!l);
  return <LessonViewBase {...props} relatedLessons={related} />;
}
